/* eslint-disable max-len, require-jsdoc */

const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const handleAnalytics = (...rest) => {
  const action = rest[0];
  const dataLayerObject = {};
  let tracking = false;

  const handleDropdown = (field, value) => {
    dataLayerObject['event'] = 'dropdown';
    dataLayerObject['dropdownField'] = field;
    dataLayerObject['dropdownValue'] = value;
    tracking = true;
  };

  const handleTooltip = value => {
    dataLayerObject['event'] = 'tooltip';
    dataLayerObject['tooltipField'] = 'map';
    dataLayerObject['tooltipValue'] = value;
    tracking = true;
  };

  const handleGroupPageVisit = groupId => {
    dataLayerObject['event'] = 'groupPageVisit';
    dataLayerObject['groupId'] = groupId;
    tracking = true;
  };

  const handleGroupSocialMediaClick = (groupId, method) => {
    dataLayerObject['event'] = 'groupSocialMediaClick';
    dataLayerObject['groupId'] = groupId;
    dataLayerObject['sharingMethod'] = method;
    tracking = true;
  };

  const handleGroupSearch = keyword => {
    dataLayerObject['event'] = 'groupSearch';
    dataLayerObject['searchKeyword'] = keyword;
    tracking = true;
  };

  const handleCustom = object => {
    Object.assign(dataLayerObject, object);
    tracking = true;
  };

  switch (action) {
    case 'dropdown':
      handleDropdown(rest[1], rest[2]);
      break;
    case 'tooltip':
      handleTooltip(rest[1]);
      break;
    case 'groupPageVisit':
      handleGroupPageVisit(rest[1]);
      break;
    case 'groupSocialMediaClick':
      handleGroupSocialMediaClick(rest[1], rest[2]);
      break;
    case 'groupSearch':
      handleGroupSearch(rest[1]);
      break;
    case 'custom':
      handleCustom(rest[1]);
      break;
    default:
      break;
  }

  if (tracking) {
    console.log('dataLayerObject', dataLayerObject); // @todo: remove it

    let GA_AKP;
    if (inIframe) {
      GA_AKP = {
        dataLayerSend: () => {
          window.parent.postMessage({
            dataLayerObject,
          }, '*');
        },
      };
    } else {
      GA_AKP = window.GA_AKP;
    }

    // If 'GA_AKP' object found on AKNSITE page DOM, then push 'dataLayerObject' for Analytics
    if (typeof GA_AKP !== 'undefined') {
      GA_AKP.dataLayerSend(dataLayerObject);
    }
  }
};
